<template>
  <div class="page">
    <PageHeader>
      Учет
    </PageHeader>
    <div class="content" v-if="loaded">
      <LedgerBalancesIndexComponent />
      <!-- <LedgerExchangesComponent /> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import LedgerBalancesIndexComponent from "./components/Balances";
import PageHeader from "../../ui/PageHeader.vue";
// import LedgerExchangesComponent from "./components/Exchanges";
export default {
  name: "Ledger",
  components: { PageHeader, 
    LedgerBalancesIndexComponent,
    // LedgerExchangesComponent
   },
  data: () => ({
    loaded: true
  }),
  computed: {},
  methods: {
    ...mapActions("valutes", [
      "getValutes",
      "getSortedValutes",
      "getSortedValutesWithoutForms"
    ])
  },
  async mounted() {
    await this.getSortedValutesWithoutForms();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/index.vue